// /* eslint-disable react/prop-types */
// /* eslint-disable no-unused-vars */
// import React, { useState } from "react";
// import { Table } from "antd";

// const Datatable = ({ props, columns, dataSource,summary }) => {
//   const [selectedRowKeys, setSelectedRowKeys] = useState([]);
//   const onSelectChange = (newSelectedRowKeys) => {
//     setSelectedRowKeys(newSelectedRowKeys);
//   };

//   const rowSelection = {
//     selectedRowKeys,
//     onChange: onSelectChange,
//   };
//   return (
//     <Table
//       key={props}
//       className="table datanew dataTable no-footer custom-table"
//       // rowSelection={rowSelection}
//       summary={summary}
//       columns={columns}
//       dataSource={dataSource}
//       rowKey={(record) => record.id}
//       pagination={{
//         showTotal: (total, range) =>
//           `${range[0]}-${range[1]} of ${total} items`,
//       }}
//     />
//   );
// };

// export default Datatable;

import React, { useState } from "react";
import { Table as AntdTable } from "antd";

const Datatable = ({ props, columns, dataSource, pagination, summary }) => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <AntdTable
      key={props}
      className="table datanew dataTable no-footer custom-table"
      columns={columns}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      pagination={{
        ...pagination,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
      }}
      summary={summary}
    />
  );
};

// Re-export the Summary subcomponent
Datatable.Summary = AntdTable.Summary;

export default Datatable;